module.exports = __webpack_public_path__ + "static/media/contribute-icon.5d5e13aa.svg";